import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import { deleteEvent, cloneEvent, archiveEvent } from 'src/actions/event'
import { userIdSelector } from 'src/selectors'
import MeatballLinedIcon from 'assets/icons/meatball-lined-icon.png'
import { hobnobSetHref } from '../../../../actions/utils'
import moment from 'moment-timezone'

import styles from './event-card.scss'

class EventCard extends Component {
  imageRef = null

  state = {
    showOperate: false
  }

  componentDidMount() {
    this.onLoadFlyer()
  }

  handleCloneEvent = () => {
    const { onCloneEvent, event } = this.props

    onCloneEvent({
      eventId: event.id,
      onSuccessCallback: data => {
        location.href = data.event.url
      }
    })
  }

  handleDeleteEvent = () => {
    const { onDeleteEvent, event, onDeleteEventCallback } = this.props

    onDeleteEvent({
      eventId: event.id,
      onSuccessCallback: () => {
        onDeleteEventCallback(event.id)
      }
    })
  }

  handleArchiveEvent = () => {
    const { onArchiveEvent, event, onDeleteEventCallback } = this.props

    onArchiveEvent({
      eventId: event.id,
      onSuccessCallback: () => {
        onDeleteEventCallback(event.id)
      }
    })
  }

  onLoadFlyer = () => {
    const imgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const IMG = new Image()
          let img = entry.target
          let imgSrc = img.getAttribute('data-src')
          IMG.onload = () => {
            img.setAttribute('src', imgSrc)
            observer.unobserve(entry.target)
          }
          IMG.src = imgSrc
        }
      })
    })

    imgObserver.observe(this.imageRef)
  }

  goEventDetail = () => {
    const { event } = this.props
    hobnobSetHref(event.url)
  }

  render() {
    const { event, onShowDownLoad, userId } = this.props
    const { showOperate } = this.state
    const isCreator = userId === event.user_id

    return (
      <li className={styles['event-inner']} onClick={this.goEventDetail}>
        <div className={styles['event-flyer']}>
          <img data-src={event.flyer?.watermarked_url_2x} ref={ref => (this.imageRef = ref)} />
        </div>
        <div className={styles['event-information']}>
          <div className={styles['avatar-wrapper']}>
            <UserAvatarContainer user={event.user} size={50} borderColor="#2cd4ae" />
          </div>
          <div className={styles['event-name']}>{event.name}</div>
          <div className={styles['event-operate-wrapper']}>
            <div className={styles['event-host']}>
              <div className={styles['host-name']}>
                creator:{event.user.first_name} {event.user.last_name}
              </div>
              {event.starts_at && (
                <div className={styles['event-date']}>
                  {moment.tz(event.starts_at, event.timezone).format('MMMM D, YYYY ∙ h:mm A')}
                </div>
              )}
            </div>
            <div className={styles['operate-button']}>
              <img
                src={MeatballLinedIcon}
                width="20"
                onClick={e => {
                  e.stopPropagation()
                  this.setState({ showOperate: !showOperate })
                }}
              />
              {showOperate && (
                <ul className={styles['operate-list']}>
                  {isCreator && (
                    <li
                      onClick={e => {
                        e.stopPropagation()
                        onShowDownLoad()
                        this.setState({ showOperate: false })
                      }}
                    >
                      Clone Event
                    </li>
                  )}
                  <li
                    onClick={e => {
                      e.stopPropagation()
                      this.handleArchiveEvent()
                      this.setState({ showOperate: false })
                    }}
                  >
                    Archive Event
                  </li>
                  {isCreator && (
                    <li
                      className={styles['delete-text']}
                      onClick={e => {
                        e.stopPropagation()
                        this.handleDeleteEvent()
                        this.setState({ showOperate: false })
                      }}
                    >
                      Delete Event
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      </li>
    )
  }
}

EventCard.propTypes = {
  event: PropTypes.object,
  onDeleteEvent: PropTypes.func,
  onCloneEvent: PropTypes.func,
  onDeleteEventCallback: PropTypes.func,
  onArchiveEvent: PropTypes.func,
  onShowDownLoad: PropTypes.func,
  userId: PropTypes.string
}

function mapDispatchToState(dispatch) {
  return {
    onDeleteEvent: eventId => dispatch(deleteEvent(eventId)),
    onCloneEvent: params => dispatch(cloneEvent(params)),
    onArchiveEvent: params => dispatch(archiveEvent(params))
  }
}

function mapStateToProps(state) {
  return {
    userId: userIdSelector(state)
  }
}

export default connect(mapStateToProps, mapDispatchToState)(EventCard)



// WEBPACK FOOTER //
// ./src/containers/event/EventList/EventCard/EventCard.jsx